import { cn } from "@/lib/utils";

type FormActionsProps = {
  children: React.ReactNode;
  className?: string;
};

/** Primary/submit and secondary form actions — always right-aligned. */
export function FormActions({ children, className }: FormActionsProps) {
  return (
    <div className={cn("flex flex-wrap items-center justify-end gap-2", className)}>
      {children}
    </div>
  );
}
